/* eslint-disable func-names */
/* eslint-disable no-undef */

/**
 * Sets the sizes of the items in the services block when cookies are set
 * (there are 4 items only when cookies are set)
 */
const services = () => {
  (function ($) {
    const $window = $(window);
    const $listCount = $('.c-services__list > .c-services__list-item').length;
    const $serviceEl = $('.c-services__list-inner');
    const $serviceItem = $('.c-services__list > .c-services__list-item');
    const service50 = 'c-services__list-item--50';
    const isDesktop = $window.width() >= 1024;

    const servicesCount = () => {
      $serviceItem.addClass(service50);

      $(document).ready(() => {
        // find the tallest item and make all others the same height
        const tallestElem = $('.c-services__list-inner').toArray()
          .reduce((a, b) => (a.offsetHeight > b.offsetHeight ? a : b));

        const $height = tallestElem.offsetHeight;

        $serviceEl.css('height', `${$height}px`);
      });
    };

    if (isDesktop && $listCount === 4) {
      servicesCount();
    }

    // Listen for orientation changes
    window.addEventListener('orientationchange', () => {
      // 0 is portrait 90 is landscape
      if (window.orientation === 90) {
        servicesCount();
        return;
      }

      $serviceEl.removeAttr('style');
    }, false);
  }(jQuery));
};

export default services;
